import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-349820be"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_3 = { class: "is-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("h1", null, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("a", {
      class: "ml-6",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('close')), ["enter"])),
      "aria-label": _ctx.$t('general.close'),
      tabindex: "0",
      role: "button"
    }, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("general.close")), 1)
    ], 40, _hoisted_1)
  ]))
}